import { IState } from 'shared/store';

import { selectConsultantMessageButtonAvailable } from '../newbuildingConsultant';
import { selectIsChatsEnabled } from '../offerChat';

export const selectMessageButtonAvailable = (state: IState) => {
  const isChatsEnabled = selectIsChatsEnabled(state);
  const isConsultantMessageButtonAvailable = selectConsultantMessageButtonAvailable(state);

  return isChatsEnabled || isConsultantMessageButtonAvailable;
};
